var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildIconShowers = function SvgBuildIconShowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.422"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.618 4.228s-7.317-.031-7.317 7.483H20.6c0-7.514-7.982-7.483-7.982-7.483m0 0V3.6a3 3 0 0 0-3-3H3.6a3 3 0 0 0-3 3v16.72m7.982-5.847v6.35m4.444-6.35v4.762m4.445-4.762v3.175"
  })));
};
export default SvgBuildIconShowers;